import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserState } from 'types';
import { getUser } from 'utils/storage.service';

export const initialState: UserState = {
  isAuthenticated: false,
  error: '',
  loading: true,
  currentUser: getUser()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },

    loginSuccess: (state, { payload }: PayloadAction<any>) => {
      state.currentUser = payload;
      state.isAuthenticated = true;
      state.loading = false;
    },

    loginError: (state, { payload }: PayloadAction<string>) => {
      state.error = payload;
      state.isAuthenticated = false;
      state.loading = false;
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.currentUser = {};
      state.error = '';
      state.loading = false;
    },

    logoutSuccess: (state) => {
      state.isAuthenticated = false;
      state.currentUser = {};
      state.error = '';
      state.loading = false;
    }
  }
});

export const { login, loginSuccess, loginError, logout, logoutSuccess } =
  authSlice.actions;

export default authSlice.reducer;
